module.exports = __webpack_public_path__ + "img/point.dcc03e55.svg";